import { ScoreType } from '../app/resource/score/score.types';

export function formatScoreDisplayValue(
  value: string | number | null | undefined,
  type: ScoreType,
  units = '',
): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return '';
  }

  const formattedNumber = numericValue.toLocaleString('en-US', {
    minimumFractionDigits: Number.isInteger(numericValue) ? 0 : 2,
    maximumFractionDigits: 2,
  });
  const normalizedUnits = units.trim();

  if (type === 'dollar' || normalizedUnits === '$') {
    return `$${formattedNumber}`;
  }

  if (type === 'percentage') {
    return `${formattedNumber}%`;
  }

  if (normalizedUnits === '') {
    return formattedNumber;
  }

  return `${formattedNumber} ${normalizedUnits}`;
}
